import {
  ListItem,
  // Badge,
  Checkbox,
  Paper,
  Stack,
  Box,
  Typography,
  Tooltip,
  IconButton,
  Grid,
  // Link,
} from "@mui/material";
// import Edit from "@mui/icons-material/Edit";
// import ChatIcon from "@mui/icons-material/Chat";
// import InfoIcon from "@mui/icons-material/Info";
// import FileCopyIcon from "@mui/icons-material/FileCopy";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { paginateArray } from "../helpers/paginateArray";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import RowTextField from "./RowTextField";
import RowTypeSelect from "./RowTypeSelect";
import RowOptionsSelect from "./RowOptionsSelect";
dayjs.extend(relativeTime);

export default function ChecklistRowCard(props) {
  return (
    <div>
      {paginateArray(props.rows, props.page, props.rowsPerPage).map(
        (obs, idx) => (
          <ListItem key={idx} style={{ padding: 0 }}>
            <Paper
              elevation={6}
              style={{ width: "100%", marginTop: 10, marginBottom: 10 }}
            >
              <div style={{ padding: 20 }}>
                <Stack>
                  <Box
                    sx={{
                      width: "100%",
                      height:
                        (obs["Row Type"] === "Header") |
                        (obs["Row Type"] === "Information Row")
                          ? 20
                          : 10,
                      borderRadius: 1,
                      bgcolor: obs.Selected
                        ? "primary.main"
                        : obs["Row Type"] === "Header" ||
                            obs["Row Type"] === "Information Row"
                          ? "secondary.main"
                          : "secondary.light",
                      // "&:hover": {
                      //   bgcolor: "primary.dark",
                      // },
                    }}
                  />

                  <Grid style={{ paddingTop: 20 }} container spacing={2}>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Tooltip title="Select">
                          <Checkbox
                            id={obs.id}
                            name={obs.id}
                            checked={obs.Selected ? obs.Selected : false}
                            onChange={props.handleChecked}
                          />
                        </Tooltip>
                        <Typography
                          variant="subtitle1"
                          color="secondary.light"
                        >{`Row No:`}</Typography>
                        <Typography
                          style={{ marginLeft: 6 }}
                        >{`${obs.No}`}</Typography>
                      </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }} />
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <Stack
                        style={{ paddingTop: 6 }}
                        direction="row"
                        spacing={1}
                        sx={{
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                      >
                        <Tooltip title="Move Down">
                          <IconButton
                            aria-label="Move Down"
                            disabled={idx + 1 === props.rows.length}
                            size="large"
                            onClick={() =>
                              props.onMove({ id: obs.id, direction: "Down" })
                            }
                            color={obs.Selected ? "primary" : "secondary.light"}
                          >
                            <ArrowDownwardIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Move Up">
                          <IconButton
                            aria-label="Move Up"
                            size="large"
                            disabled={idx === 0}
                            onClick={() =>
                              props.onMove({ id: obs.id, direction: "Up" })
                            }
                            color={obs.Selected ? "primary" : "secondary.light"}
                          >
                            <ArrowUpwardIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Delete Row">
                          <IconButton
                            aria-label="Delete Row"
                            size="large"
                            disabled={!props.allowDelete}
                            onClick={() => props.onDeleteRow(obs.id)}
                            color={obs.Selected ? "primary" : "secondary.light"}
                          >
                            <DeleteForeverIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Grid style={{ paddingTop: 20 }} container spacing={2}>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <RowTypeSelect
                        id={obs.id}
                        onRowTypeChange={props.onRowTypeChange}
                        value={obs["Row Type"]}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 8 }}>
                      <RowTextField
                        id={obs.id}
                        type={obs["Row Type"]}
                        value={obs["Row Text"]}
                        onTextChange={props.onTextChange}
                      />
                    </Grid>
                  </Grid>
                  {obs["Row Type"] === "Single Select" ||
                  obs["Row Type"] === "Multiple Select" ? (
                    <Grid style={{ paddingTop: 20 }} container spacing={2}>
                      <Grid size={{ xs: 12, sm: 4 }}>
                        <RowOptionsSelect
                          choosen={obs["Select Options"]}
                          onRowOptionsChange={props.onRowOptionsChange}
                          id={obs.id}
                        />
                      </Grid>
                    </Grid>
                  ) : null}
                </Stack>
              </div>
            </Paper>
          </ListItem>
        ),
      )}
    </div>
  );
}
